import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import {environment} from "../../../../environments/environment";
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class OrcsService {

  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public getOrcs(search: string, status: number, monthStart: string, monthEnd: string, plannedDateForFilterMonth: string) {
      const params = new  HttpParams()
        .set('search', search)
        .set('monthStart', monthStart)
        .set('monthEnd', monthEnd)
        .set('status', status.toString())
        .set('plannedDate', plannedDateForFilterMonth);

      return this.httpClient.get(this.SERVER_URL + 'orcs/orcs/getOrcs', {params});
  }

    public saveOrc(data: any, userId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'orcs/orcs/saveOrc',
            {
                date: data.date,
                plannedDate: data.plannedDate,
                objective: data.objective,
                clientId: data.client,
                newClient: data.newClient,
                status: data.status,
                amount: data.amount,
                amountDate: data.amountDate,
                observation: data.observation,
                registrationNumber: data.registrationNumber,
                admissionDate: data.admissionDate,
                commission: data.commission,
                search: data.search,
                userId: userId,
                type: data.type,
                user_id: data.user_id
            },
            { headers });
    }

    public updateOrc(data: any, userId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'orcs/orcs/updateOrc',
            {
                id: data.id,
                date: data.date,
                plannedDate: data.plannedDate,
                objective: data.objective,
                clientId: data.client,
                status: data.status,
                amount: data.amount,
                amountDate: data.amountDate,
                observation: data.observation,
                search: data.search,
                registrationNumber: data.registrationNumber,
                admissionDate: data.admissionDate,
                commission: data.commission,
                type: data.type,
                user_id: data.user_id
            },
            { headers });
    }

    public deleteOrc(orcId: string) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        return this.httpClient.post(this.SERVER_URL + 'orcs/orcs/deleteOrc',
            {
                orcId: orcId
            },
            { headers });
    }

    public uploadFile(file, userId, formId) {
        const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

        const formData: FormData = new FormData();
        formData.append('file', file, `${file.name}${formId}`);

        return this.httpClient.post(this.SERVER_URL + 'orcs/orcs/uploadFile',
            formData, {
                reportProgress: true,
                responseType: 'json'
            });
    }

    public sendOrcEmail(userId, toEmail, fromEmail, subject, body, files, formId) {
        const params = new  HttpParams()
            .set('userId', userId)
            .set('toEmail', toEmail)
            .set('fromEmail', fromEmail)
            .set('subject', subject)
            .set('body', body)
            .set('files', files)
            .set('formId', formId);

        return this.httpClient.get(this.SERVER_URL + 'orcs/orcs/sendOrcEmail', {params});
    }
}
